import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shenhe",
  "use": "icon-shenhe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shenhe\"><path d=\"M512 64c103.04 0 186.496 87.296 186.496 195.008 0 54.528-21.376 103.808-55.872 139.2l0.512-0.96c-14.272 21.44-25.472 66.56-25.472 102.08 0 59.008 22.144 111.552 72.128 135.744L896 635.008V960H128V635.008h198.656l3.2-1.536c48.256-24.832 79.872-76.416 79.872-134.144 0-31.424-8.768-70.4-20.672-93.76a198.144 198.144 0 0 1-63.552-146.56C325.504 151.296 408.96 64 512 64z m296.96 662.016H215.04v142.976h593.92v-142.976zM534.4 452.608a171.52 171.52 0 0 1-41.28 0.384c2.432 15.68 3.648 31.36 3.648 46.336 0 49.792-14.592 96.704-40.064 135.68h114.112a247.808 247.808 0 0 1-40.128-135.68c0-15.04 1.28-30.848 3.712-46.72zM512 155.008c-54.912 0-99.456 46.528-99.456 104 0 57.408 44.544 104 99.456 104 54.912 0 99.456-46.592 99.456-104 0-57.472-44.544-104-99.456-104z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shenhe.svg
// module id = T0Hs
// module chunks = 30